import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PortalAccessTokenService } from '../../services/portal-access-token.service';

type Step = 'idle' | 'sending' | 'success' | 'error';

@Component({
  selector: 'app-portal-access-request',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './portal-access-request.component.html',
  styleUrl: './portal-access-request.component.scss',
})
export class PortalAccessRequestComponent {
  private portalSvc = inject(PortalAccessTokenService);

  email = '';
  step: Step = 'idle';
  errorMessage = '';

  get isValidEmail(): boolean {
    const trimmed = this.email.trim();
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);
  }

  submit(): void {
    if (!this.isValidEmail || this.step === 'sending') return;

    this.step = 'sending';
    this.portalSvc.sendByEmail(this.email.trim()).subscribe({
      next: () => {
        this.step = 'success';
      },
      error: () => {
        this.step = 'error';
        this.errorMessage = 'We could not send the link right now. Please try again shortly.';
      },
    });
  }

  reset(): void {
    this.email = '';
    this.step = 'idle';
    this.errorMessage = '';
  }
}
